module.exports = __webpack_public_path__ + "images/97c2ad4a73b44783f53241252b5e5543e11840773d21604e2744e82fb3996c7d.svg";